import React from 'react';
import { Icon, SimpleModal } from '@livable/saas-react-components';
import { Button } from '@mui/material';
import { observer } from 'mobx-react-lite';
import { useTranslation } from 'react-i18next';
import { GetForm } from './modalForm';
export const AddProviderModalV2 = observer(_ref => {
  let isEditMode = _ref.isEditMode,
    trigger = _ref.trigger,
    provider = _ref.provider,
    propertyId = _ref.propertyId,
    onSave = _ref.onSave,
    isDetailsPage = _ref.isDetailsPage;
  const _useTranslation = useTranslation(),
    t = _useTranslation.t;
  const defaultTrigger = /*#__PURE__*/React.createElement(Button, {
    variant: "actionButton",
    'custom-attribute': '151-add-provider-modal-v2'
  }, /*#__PURE__*/React.createElement(Icon, {
    type: "plus"
  }), /*#__PURE__*/React.createElement("span", {
    className: "actionText"
  }, t('add_new_property_flow.cant_find_provider')));
  return /*#__PURE__*/React.createElement(SimpleModal, {
    trigger: trigger || defaultTrigger,
    title: isEditMode ? t('add_new_property_flow.edit_new_provider') : t('add_new_property_flow.add_new_provider'),
    noFooter: true,
    noPadding: true,
    noLeftButton: true,
    variant: "staticHeight"
  }, /*#__PURE__*/React.createElement(GetForm, {
    provider: provider,
    isEditMode: isEditMode,
    propertyId: propertyId,
    hideNotEnabledExternal: false,
    onSave: onSave,
    isDetailsPage: isDetailsPage
  }));
});